import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}));

const YEAR = new Date().getFullYear();

const Footer = (props) => {
  const { className, ...rest } = props;
  const { classes, cx } = useStyles();

  return (
    <div {...rest} className={cx(classes.root, className)}>
      <Typography variant="body1">&copy; MinhaAgenda. {YEAR}</Typography>
      <Typography variant="caption">Todos os direitos reservados.</Typography>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default Footer;
